const checkFor = (code, errors) => {
  return (
    errors &&
    errors.find(({ extensions = {} }) => {
      return extensions.code === code;
    })
  );
};

// CheckGraphQLErrorForCode checks a ApolloError for a specific error code
const CheckGraphQLErrorForCode = ({ graphQLErrors }, code) => {
  return checkFor(code, graphQLErrors);
};

// Throws an error using the given message if the given code is present, otherwise
// use the fallback message, or the original error message.
const ThrowGraphQLError = (e, code, message, fallback = null) => {
  if (CheckGraphQLErrorForCode(e, code)) {
    throw new Error(message);
  } else {
    throw new Error(fallback || e.message || "Undefined error");
  }
};

// ValidationErrorReasons returns the reasons given by the backend for any
// validation errors in an ApolloError. E.g. "Group has child groups".
const ValidationErrorReasons = ({ graphQLErrors } = {}) => {
  return (graphQLErrors || [])
    .filter(({ extensions = {} }) => extensions.code === "VALIDATION_ERROR")
    .reduce(
      (acc, { extensions }) =>
        acc.concat(
          (extensions.exception && extensions.exception.validationErrors) || []
        ),
      []
    );
};

export { CheckGraphQLErrorForCode, ThrowGraphQLError, ValidationErrorReasons };
